export default __webpack_public_path__ + "static/media/0069.a810d59b.png";